module.exports = __webpack_public_path__ + "static/img/defaultImage.491d1a0a.png";